import CircleErrorIcon from './CircleErrorIcon'

export default CircleErrorIcon
